import type { EditConfigUI } from '@types';
import produce from 'immer';

/**
 * 修改ui数据的值, 把类似`255,255,255,1`字段的值改为`rgba(255,255,255,1)`, 如果是`#ffffff`格式的颜色值则不做处理
 * 用于给`pano-menu`, `pano-custom-button`使用
 */
export function modifyUiValue(uiData: EditConfigUI | undefined | null) {
  if (!uiData) return uiData;
  return produce(uiData, (draftState) => {
    const keys = Object.keys(draftState) as (keyof EditConfigUI)[];
    const regex =
      /^\d{1,3},\d{1,3},\d{1,3},(0(\.\d{1,2})?|1(\.0{1,2})?|\.\d{1,2})$/;
    keys.forEach((key) => {
      const value = draftState[key];
      if (typeof value === 'string' && regex.test(value)) {
        draftState[key] = `rgba(${value})`;
      }
    });
  });
}
